import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Budget from "../../../containers/modules/accounting/budget";

export default function BudgetRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="budget"
      index
      element={
        <AccessControl
          name={"Budget List"}
          auth={authUser}
          component={() => <Budget />}
        />
      }
    />
  );
}
